import { lazy } from 'react';

const MainPageAsync = lazy(() => import('./MainPage'));

export default MainPageAsync;
